/* eslint-disable max-len */
const FEATURED_EN_US_CARRIER_CODES = ['AMT', 'GLI', 'PPL', 'USSLE', 'USOUR', 'USPNY', 'USWAD', 'USMTZ', 'GOB', 'BST', 'USTOR', 'MRT', 'ADT', 'USIND', 'FTW', 'BTW', 'CCC', 'BSB', 'USJFL', 'RCU', 'CATEX', 'CAQKS', 'VIA'];
const FEATURED_EN_CA_CARRIER_CODES = ['AMT', 'VIA', 'CAONO', 'GLI', 'CACLD', 'RAR', 'MEB', 'CAQKS', 'CARDX', 'CAMTB', 'USSLE', 'DEFLX', 'PPL', 'ADT', 'CABFL'];
const FEATURED_EN_GB_CARRIER_CODES = ['GBNXP', 'GBADK', 'FRBBB', 'IECLK', 'IEGOB', 'DEDBN', 'DEFLX', 'DEFLT', 'CZRJT', 'NLCBX', 'PLSBD', 'ISFLY', 'AMT', 'GLI', 'VIA'];
const FEATURED_ES_MX_CARRIER_CODES = ['TMX', 'TUFI', 'USTOR', 'TNO', 'TND', 'TAM', 'COA', 'MXACN', 'USELX', 'AVE', 'SDR', 'MXBJF', 'AMT', 'GLI', 'VIA'];
const FEATURED_ES_ES_CARRIER_CODES = ['ESSAG', 'FRBBB', 'ESPLN', 'DEFLX', 'DEDBN', 'ISFLY', 'BGUII', 'ESNAR', 'FRELN', 'AMT', 'GLI', 'USTOR', 'TMX', 'TUFI', 'ESABB'];
const FEATURED_FR_FR_CARRIER_CODES = ['FRBBB', 'ISFLY', 'FRELN', 'DEDBN', 'DEFLX', 'DEFLT', 'ATRJT', 'PLSBD', 'BGUII', 'GBNXP', 'FRNPB', 'AMT', 'GLI', 'VIA', 'GBADK'];
const FEATURED_FR_CA_CARRIER_CODES = ['AMT', 'VIA', 'CAONO', 'GLI', 'CACLD', 'RAR', 'MEB', 'CAQKS', 'CARDX', 'CAMTB', 'USSLE', 'DEFLX', 'PPL', 'ADT', 'CABFL'];
const FEATURED_DE_DE_CARRIER_CODES = ['DEDBN', 'DEFLX', 'DEFLT', 'DEMNM', 'DEERX', 'FRBBB', 'PLSBD', 'PLEST', 'DEVLB', 'DEVLX', 'DETLX', 'DEOPB', 'ITMAR', 'GBNXP', 'HRCJT', 'HRGLB', 'HRATS', 'ATRJT', 'UAEUC', 'AMT', 'GLI', 'VIA', 'TUFI'];
const FEATURED_NL_NL_CARRIER_CODES = ['NLCBX', 'FRBBB', 'FRELN', 'DEFLX', 'DEFLT', 'DEDBN', 'GBNXP', 'PLSBD', 'CZRJT', 'ISFLY', 'ATRJT', 'AMT', 'GLI', 'VIA', 'GBADK'];
const FEATURED_IT_IT_CARRIER_CODES = ['ISFLY', 'DEDBN', 'DEFLT', 'DEFLX', 'ITALF', 'ITCVR', 'ITLAV', 'ITSTS', 'ITMCS', 'ITREX', 'ITFME', 'ITMAB', 'ITMRZ', 'ITBLT', 'ITBUC', 'FRBBB', 'ITLSC', 'ITBIG', 'CZRJT', 'PLSBD', 'AMT', 'GLI', 'GBNXP'];

/* eslint-disable */

const CARRIER_DATA = {
    ADT: {
        carrierCode: 'ADT',
        pageSlug: 'new-york-trailways-137',
        name: 'New York Trailways',
    },
    AMT: {
        carrierCode: 'AMT',
        pageSlug: 'amtrak-train-146',
        name: 'Amtrak',
    },
    ATRJT: {
        carrierCode: 'ATRJT',
        pageSlug: 'railjet-238',
        name: 'Railjet',
    },
    AVE: {
        carrierCode: 'AVE',
        pageSlug: 'ave-senda-169',
        name: 'AVE',
    },
    BSB: {
        carrierCode: 'BSB',
        pageSlug: 'barons-bus-lines-121',
        name: 'Barons Bus',
    },
    BST: {
        carrierCode: 'BST',
        pageSlug: 'bestbus-157',
        name: 'BestBus',
    },
    BTW: {
        carrierCode: 'BTW',
        pageSlug: 'burlington-trailways-160',
        name: 'Burlington Trailways',
    },
    CACLD: {
        carrierCode: 'CACLD',
        pageSlug: 'cold-shot-bus-1338',
        name: 'Cold Shot Bus',
    },
    CAMTB: {
        carrierCode: 'CAMTB',
        pageSlug: 'maritime-bus-241',
        name: 'Maritime Bus',
    },
    CAQKS: {
        carrierCode: 'CAQKS',
        pageSlug: 'quick-shuttle-260',
        name: 'Quick Shuttle',
    },
    CCC: {
        carrierCode: 'CCC',
        pageSlug: 'concord-coach-lines-141',
        name: 'Concord Coach Lines',
    },
    COA: {
        carrierCode: 'COA',
        pageSlug: 'coahuilenses-170',
        name: 'Coahuilenses',
    },
    CZRJT: {
        carrierCode: 'CZRJT',
        pageSlug: 'regiojet-267',
        name: 'RegioJet',
    },
    DEDBN: {
        carrierCode: 'DEDBN',
        pageSlug: 'deutsche-bahn-db-196',
        name: 'Deutsche Bahn',
    },
    DEFLT: {
        carrierCode: 'DEFLT',
        pageSlug: 'flixtrain-270',
        name: 'Locomore - FlixBus',
    },
    DEFLX: {
        carrierCode: 'DEFLX',
        pageSlug: 'flixbus-206',
        name: 'FlixBus',
    },
    FRBBB: {
        carrierCode: 'FRBBB',
        pageSlug: 'blablabus-1955',
        name: 'BlaBlaBus',
    },
    FTW: {
        carrierCode: 'FTW',
        pageSlug: 'fullington-trailways-129',
        name: 'Fullington Trailways',
    },
    GBADK: {
        carrierCode: 'GBADK',
        pageSlug: 'air-decker-247',
        name: 'Air Decker',
    },
    GBNXP: {
        carrierCode: 'GBNXP',
        pageSlug: 'national-express-coach-224',
        name: 'National Express Coach',
    },
    GLI: {
        carrierCode: 'GLI',
        pageSlug: 'greyhound-bus-lines-139',
        name: 'Greyhound',
    },
    GOB: {
        carrierCode: 'GOB',
        pageSlug: 'gobuses-125',
        name: 'Go Buses',
    },
    HRCJT: {
        carrierCode: 'HRCJT',
        pageSlug: 'crnja-tours-271',
        name: 'Črnja Tours',
    },
    IECLK: {
        carrierCode: 'IECLK',
        pageSlug: 'irish-citylink-268',
        name: 'Irish Citylink',
    },
    IEGOB: {
        carrierCode: 'IEGOB',
        pageSlug: 'gobus-ie-269',
        name: 'GoBus.ie',
    },
    ISFLY: {
        carrierCode: 'ISFLY',
        pageSlug: 'flybus-245',
        name: 'Flybus Iceland',
    },
    ITLAV: {
        carrierCode: 'ITLAV',
        pageSlug: 'l-aurora-viaggi-248',
        name: 'L\'Aurora Viaggi',
    },
    MEB: {
        carrierCode: 'MEB',
        pageSlug: 'ebus-38',
        name: 'ebus Canada',
    },
    MRT: {
        carrierCode: 'MRT',
        pageSlug: 'miller-transportation-151',
        name: 'Miller Transportation',
    },
    NLCBX: {
        carrierCode: 'NLCBX',
        pageSlug: 'citybusexpress-243',
        name: 'CityBus Express',
    },
    PPL: {
        carrierCode: 'PPL',
        pageSlug: 'peter-pan-bus-lines-132',
        name: 'Peter Pan',
    },
    RAR: {
        carrierCode: 'RAR',
        pageSlug: 'red-arrow-98',
        name: 'Red Arrow',
    },
    RCU: {
        carrierCode: 'RCE', // RCU is actually a service group, RCE is red coach economy
        pageSlug: 'red-coach-148',
        name: 'Red Coach',
    },
    SDR: {
        carrierCode: 'SDR',
        pageSlug: 'sendor-1048',
        name: 'SENDOR',
    },
    TAM: {
        carrierCode: 'TAM',
        pageSlug: 'transporte-tamaulipas-168',
        name: 'Transporte Tamaulipas',
    },
    TMX: {
        carrierCode: 'TMX',
        pageSlug: 'turimex-internacional-153',
        name: 'Turimex',
    },
    TND: {
        carrierCode: 'TND',
        pageSlug: 'transportes-del-norte-diamante-1074',
        name: 'Transportes del Norte Diamante',
    },
    TNO: {
        carrierCode: 'TNO',
        pageSlug: 'transportes-del-norte-tdn-164',
        name: 'Transportes del Norte',
    },
    TUFI: {
        carrierCode: 'TUFI',
        pageSlug: 'tufesa-international-123',
        name: 'Tufesa Internacional',
    },
    USELX: {
        carrierCode: 'USELX',
        pageSlug: 'el-expreso-bus-235',
        name: 'El Expreso',
    },
    USIND: {
        carrierCode: 'USIND',
        pageSlug: 'indian-trails-17',
        name: 'Indian Trails',
    },
    USJFL: {
        carrierCode: 'USJFL',
        pageSlug: 'jefferson-bus-lines-171',
        name: 'Jefferson Lines',
    },
    USOUR: {
        carrierCode: 'USOUR',
        pageSlug: 'ourbus-265',
        name: 'OurBus',
    },
    USTOR: {
        carrierCode: 'USTOR',
        pageSlug: 'tornado-bus-company-74',
        name: 'Tornado Bus',
    },
    VIA: {
        carrierCode: 'VIA',
        pageSlug: 'via-rail-133',
        name: 'VIA Rail',
    },
    ITMAR: {
        carrierCode: 'ITMAR',
        pageSlug: 'marino-1081',
        name: 'Marino',
    },
    CAONO: {
        carrierCode: 'CAONO',
        pageSlug: 'ontario-northland-1189',
        name: 'Ontario Northland',
    },
    ITBUC: {
        carrierCode: 'ITBUC',
        pageSlug: 'buscenter-1933',
        name: 'BusCenter',
    },
    PLSBD: {
        carrierCode: 'PLSBD',
        pageSlug: 'sinbad-262',
        name: 'Sindbad',
    },
    DETLX: {
        carrierCode: 'DETLX',
        pageSlug: 'trilex-1022',
        name: 'trilex',
    },
    USPNY: {
        carrierCode: 'USPNY',
        pageSlug: 'pandany-bus-1057',
        name: 'PandaNY Bus',
    },
    ITCVR: {
        carrierCode: 'ITCVR',
        pageSlug: 'calanda-viaggi-1132',
        name: 'Calanda Viaggi',
    },
    ITMAB: {
        carrierCode: 'ITMAB',
        pageSlug: 'metauro-bus-1205',
        name: 'Metauro Bus',
    },
    HRATS: {
        carrierCode: 'HRATS',
        pageSlug: 'autotrans-by-arriva-1216',
        name: 'Autotrans by Arriva',
    },
    CARDX: {
        carrierCode: 'CARDX',
        pageSlug: 'rider-express-1333',
        name: 'Rider Express',
    },
    DEOPB: {
        carrierCode: 'DEOPB',
        pageSlug: 'oberpfalzbahn-1019',
        name: 'oberpfalzbahn',
    },
    HRGLB: {
        carrierCode: 'HRGLB',
        pageSlug: 'globtour-1040',
        name: 'Globtour',
    },
    ITBLT: {
        carrierCode: 'ITBLT',
        pageSlug: 'baltour-1079',
        name: 'Baltour',
    },
    ITMRZ: {
        carrierCode: 'ITMRZ',
        pageSlug: 'marozzi-1083',
        name: 'Marozzi',
    },
    MXACN: {
        carrierCode: 'MXACN',
        pageSlug: 'acn-autobuses-1171',
        name: 'ACN Autobuses',
    },
    ITALF: {
        carrierCode: 'ITALF',
        pageSlug: 'autolinee-federico-1919',
        name: 'Autolinee Federico',
    },
    PLEST: {
        carrierCode: 'PLEST',
        pageSlug: 'est-lorek-gdansk-1072',
        name: 'EST Lorek Gdansk',
    },
    ITFME: {
        carrierCode: 'ITFME',
        pageSlug: 'fiumicino-express-1133',
        name: 'Fiumicino Express',
    },
    ESNAR: {
        carrierCode: 'ESNAR',
        pageSlug: 'naviera-armas-1194',
        name: 'Naviera Armas',
    },
    ITBIG: {
        carrierCode: 'ITBIG',
        pageSlug: 'bigbus-1337',
        name: 'BigBus',
    },
    IEEAG: {
        carrierCode: 'IEEAG',
        pageSlug: 'eireagle-com-272',
        name: 'eireagle.com',
    },
    DEMNM: {
        carrierCode: 'DEMNM',
        pageSlug: 'metronom-1017',
        name: 'metronom',
    },
    DEERX: {
        carrierCode: 'DEERX',
        pageSlug: 'erixx-1012',
        name: 'erixx',
    },
    USWAD: {
        carrierCode: 'USWAD',
        pageSlug: 'wanda-coach-1076',
        name: 'Wanda Coach',
    },
    FRNPB: {
        carrierCode: 'FRNPB',
        pageSlug: 'navette-paris-beauvais-1184',
        name: 'Navette Paris-Beauvais',
    },
    ESSAG: {
        carrierCode: 'ESSAG',
        pageSlug: 'sagales-1223',
        name: 'Sagales',
    },
    USMTZ: {
        carrierCode: 'USMTZ',
        pageSlug: 'martz-1953',
        name: 'Martz Bus',
    },
    DEVLB: {
        carrierCode: 'DEVLB',
        pageSlug: 'vogtlandbahn-1025',
        name: 'vogtlandbahn',
    },
    DEVLX: {
        carrierCode: 'DEVLX',
        pageSlug: 'vlexx-1028',
        name: 'vlexx',
    },
    ITLSC: {
        carrierCode: 'ITLSC',
        pageSlug: 'liscio-1080',
        name: 'Liscio',
    },
    UAEUC: {
        carrierCode: 'UAEUC',
        pageSlug: 'euroclub-1178',
        name: 'Euroclub',
    },
    ITMCS: {
        carrierCode: 'ITMCS',
        pageSlug: 'miccolis-spa-1224',
        name: 'Miccolis Spa',
    },
    ITSTS: {
        carrierCode: 'ITSTS',
        pageSlug: 'sita-1085',
        name: 'Sita',
    },
    MXBJF: {
        carrierCode: 'MXBJF',
        pageSlug: 'baja-ferries-1195',
        name: 'Baja Ferries',
    },
    FRELN: {
        carrierCode: 'FRELN',
        pageSlug: 'eurolines-france-1201',
        name: 'Eurolines France',
    },
    IEIRF: {
        carrierCode: 'IEIRF',
        pageSlug: 'irish-ferries-1228',
        name: 'Irish Ferries',
    },
    ITREX: {
        carrierCode: 'ITREX',
        pageSlug: 'roma-express-1920',
        name: 'Roma Express',
    },
    BGUII: {
        carrierCode: 'BGUII',
        pageSlug: 'union-ivkoni-international-1916',
        name: 'Union Ivkoni',
    },
    ESPLN: {
        carrierCode: 'ESPLN',
        pageSlug: 'bus-plana-1137',
        name: 'Bus Plana',
    },
    PRA: {
        carrierCode: 'PRA',
        pageSlug: 'peoria-charter-company-135',
        name: 'Peoria Charter Company',
    },
    CATEX: {
        carrierCode: 'CATEX',
        pageSlug: 'tour-express-2045',
        name: 'Tour Express',
    },
    CABFL: {
        carrierCode: 'CABFL',
        pageSlug: 'bay-ferries-limited-1192',
        name: 'Bay Ferries Limited',
    },
    ESABB: {
        carrierCode: 'ESABB',
        pageSlug: 'aerobus-barcelona-1136',
        name: 'Aerobus Barcelona',
    },
    USSLE: {
        carrierCode: 'USSLE',
        pageSlug: 'salt-lake-express-2051',
        name: 'Salt Lake Express',
    },
};

const BUS_C2C_DATA = {
    'en-us': [
        {
            departCity: 'Boston',
            arriveCity: 'NYC',
            url: '/bus/us-ma/boston/us-ny/new-york',
        },
        {
            departCity: 'NYC',
            arriveCity: 'Boston',
            url: '/bus/us-ny/new-york/us-ma/boston',
        },
        {
            departCity: 'DC',
            arriveCity: 'NYC',
            url: '/bus/us-dc/washington/us-ny/new-york',
        },
        {
            departCity: 'LA',
            arriveCity: 'Vegas',
            url: '/bus/us-ca/los-angeles/us-nv/las-vegas',
        },
        {
            departCity: 'Dallas',
            arriveCity: 'Houston',
            url: '/bus/us-tx/dallas/us-tx/houston',
        },
        {
            departCity: 'Houston',
            arriveCity: 'Dallas',
            url: '/bus/us-tx/houston/us-tx/dallas',
        },
        {
            departCity: 'Baltimore',
            arriveCity: 'NYC',
            url: '/bus/us-md/baltimore/us-ny/new-york',
        },
        {
            departCity: 'NYC',
            arriveCity: 'Albany',
            url: '/bus/us-ny/new-york/us-ny/albany',
        },
        {
            departCity: 'Orlando',
            arriveCity: 'Miami',
            url: '/bus/us-fl/orlando/us-fl/miami',
        },
        {
            departCity: 'Philadelphia',
            arriveCity: 'NYC',
            url: '/bus/us-pa/philadelphia/us-ny/new-york',
        },
    ],
    'de-de': [
        {
            departCity: 'München',
            arriveCity: 'Berlin',
            url: '/bus/de-by/munich/de-be/berlin',
        },
        {
            departCity: 'Hamburg',
            arriveCity: 'Berlin',
            url: '/bus/de-hh/hamburg/de-be/berlin',
        },
        {
            departCity: 'München',
            arriveCity: 'Wein',
            url: '/bus/de-by/munich/at/vienna',
        },
        {
            departCity: 'Frankfurt',
            arriveCity: 'Berlin',
            url: '/bus/de-he/frankfurt/de-be/berlin',
        },
        {
            departCity: 'Dortmund',
            arriveCity: 'Berlin',
            url: '/bus/de-nw/dortmund/de-be/berlin',
        },
        {
            departCity: 'Berlin',
            arriveCity: 'Nuremberg',
            url: '/bus/de-be/berlin/de-by/nuremberg',
        },
        {
            departCity: 'Frankfurt',
            arriveCity: 'Amterdam',
            url: '/bus/de-he/frankfurt/nl-nh/amsterdam',
        },
        {
            departCity: 'Essen',
            arriveCity: 'Berlin',
            url: '/bus/de-nw/essen/de-be/berlin',
        },
    ],
    'en-ca': [
        {
            departCity: 'Edmonton',
            arriveCity: 'Calgary',
            url: '/bus/ca-ab/edmonton/ca-ab/calgary',
        },
        {
            departCity: 'Calgary',
            arriveCity: 'Edmonton',
            url: '/bus/ca-ab/calgary/ca-ab/edmonton',
        },
        {
            departCity: 'Toronto',
            arriveCity: 'New York',
            url: '/bus/ca-on/toronto/us-ny/new-york',
        },
        {
            departCity: 'New York',
            arriveCity: 'Toronto',
            url: '/bus/us-ny/new-york/ca-on/toronto',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Seattle',
            url: '/bus/ca-bc/vancouver/us-wa/seattle',
        },
        {
            departCity: 'Seattle',
            arriveCity: 'Vancouver',
            url: '/bus/us-wa/seattle/ca-bc/vancouver',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Kelowna',
            url: '/bus/ca-bc/vancouver/ca-bc/kelowna',
        },
        {
            departCity: 'Kelowna',
            arriveCity: 'Vancouver',
            url: '/bus/ca-bc/kelowna/ca-bc/vancouver',
        },
    ],
    'en-gb': [
        {
            departCity: 'Birmigham',
            arriveCity: 'Blackpool',
            url: '/bus/gb-bir/birmingham/gb-bpl/blackpool',
        },
        {
            departCity: 'Bristol',
            arriveCity: 'London',
            url: '/bus/gb-bst/bristol/gb-lnd/london',
        },
        {
            departCity: 'Leicester',
            arriveCity: 'London',
            url: '/bus/gb-lce/leicester/gb-lnd/london',
        },
        {
            departCity: 'London',
            arriveCity: 'Sheffield',
            url: '/bus/gb-lnd/london/gb-shf/sheffield',
        },
        {
            departCity: 'London',
            arriveCity: 'Cardiff',
            url: '/bus/gb-lnd/london/gb-crf/cardiff',
        },
        {
            departCity: 'London',
            arriveCity: 'Birmingham',
            url: '/bus/gb-lnd/london/gb-bir/birmingham',
        },
        {
            departCity: 'Leeds',
            arriveCity: 'London',
            url: '/bus/gb-lds/leeds/gb-lnd/london',
        },
        {
            departCity: 'Sawnsea',
            arriveCity: 'London',
            url: '/bus/gb-swa/swansea/gb-lnd/london',
        },
    ],
    'es-es': [
        {
            departCity: 'Girona',
            arriveCity: 'Barcelona',
            url: '/bus/es-gi/girona/es-b/barcelona',
        },
        {
            departCity: 'Sevilla',
            arriveCity: 'Valencia',
            url: '/bus/es-se/seville/es-v/valencia',
        },
        {
            departCity: 'Barcelona',
            arriveCity: 'Figueres',
            url: '/bus/es-b/barcelona/es-gi/figueres',
        },
        {
            departCity: 'Malaga',
            arriveCity: 'Lisbon',
            url: '/bus/es-ma/malaga/pt/lisbon',
        },
        {
            departCity: 'Madrid',
            arriveCity: 'Barcelona',
            url: '/bus/es-md/madrid/es-b/barcelona',
        },
        {
            departCity: 'Barcelona',
            arriveCity: 'Paris',
            url: '/bus/es-b/barcelona/fr/paris',
        },
        {
            departCity: 'Madrid',
            arriveCity: 'Bilbao',
            url: '/bus/es-md/madrid/es-bi/bilbao',
        },
        {
            departCity: 'Blanes',
            arriveCity: 'Girona',
            url: '/bus/es-gi/blanes/es-gi/girona',
        },
    ],
    'es-mx': [
        {
            departCity: 'Mexico DF',
            arriveCity: 'Tijuana',
            url: '/bus/mx-cmx/mexico-city/mx-bcn/tijuana',
        },
        {
            departCity: 'Nueva York',
            arriveCity: 'Boston',
            url: '/bus/us-ny/new-york/us-ma/boston',
        },
        {
            departCity: 'Washington DC',
            arriveCity: 'Nueva York',
            url: '/bus/us-dc/washington/us-ny/new-york',
        },
        {
            departCity: 'Nueva York',
            arriveCity: 'Washington DC',
            url: '/bus/us-ny/new-york/us-dc/washington',
        },
        {
            departCity: 'Filadelfia',
            arriveCity: 'Nueva York',
            url: '/bus/us-pa/philadelphia/us-ny/new-york',
        },
        {
            departCity: 'Nueva York',
            arriveCity: 'Filadelfia',
            url: '/bus/us-ny/new-york/us-pa/philadelphia',
        },
        {
            departCity: 'Baltimore',
            arriveCity: 'Nueva York',
            url: '/bus/us-md/baltimore/us-ny/new-york',
        },
        {
            departCity: 'Nueva York',
            arriveCity: 'Baltimore',
            url: '/bus/us-ny/new-york/us-md/baltimore',
        },
    ],
    'fr-ca': [
        {
            departCity: 'Montréal',
            arriveCity: 'New York',
            url: '/bus/ca-qc/montreal/us-ny/new-york',
        },
        {
            departCity: 'New York',
            arriveCity: 'Montréal',
            url: '/bus/us-ny/new-york/ca-qc/montreal',
        },
        {
            departCity: 'Montréal',
            arriveCity: 'Québec',
            url: '/bus/ca-qc/montreal/ca-qc/quebec-city',
        },
        {
            departCity: 'Québec',
            arriveCity: 'Montréal',
            url: '/bus/ca-qc/quebec-city/ca-qc/montreal',
        },
        {
            departCity: 'Montréal',
            arriveCity: 'Toronto',
            url: '/bus/ca-qc/montreal/ca-on/toronto',
        },
        {
            departCity: 'Toronto',
            arriveCity: 'Montréal',
            url: '/bus/ca-on/toronto/ca-qc/montreal',
        },
        {
            departCity: 'Montréal',
            arriveCity: 'Vancouver',
            url: '/bus/ca-qc/montreal/ca-bc/vancouver',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Montréal',
            url: '/bus/ca-bc/vancouver/ca-qc/montreal',
        },
    ],
    'fr-fr': [
        {
            departCity: 'London',
            arriveCity: 'Paris',
            url: '/bus/gb-lnd/london/fr/paris',
        },
        {
            departCity: 'Paris',
            arriveCity: 'London',
            url: '/bus/fr/paris/gb-lnd/london',
        },
        {
            departCity: 'Paris',
            arriveCity: 'Berlin',
            url: '/bus/fr/paris/de-be/berlin',
        },
        {
            departCity: 'Barcelona',
            arriveCity: 'Paris',
            url: '/bus/es-b/barcelona/fr/paris',
        },
        {
            departCity: 'Nice',
            arriveCity: 'Paris',
            url: '/bus/fr/nice/fr/paris',
        },
        {
            departCity: 'Bruxelles',
            arriveCity: 'Paris',
            url: '/bus/be-bru/brussels/fr/paris',
        },
        {
            departCity: 'Lyon',
            arriveCity: 'Paris',
            url: '/bus/fr/lyon/fr/paris',
        },
        {
            departCity: 'Milan',
            arriveCity: 'Paris',
            url: '/bus/it-mi/milan/fr/paris',
        },
    ],
    'it-it': [
        {
            departCity: 'Roma',
            arriveCity: 'Positano',
            url: '/bus/it-rm/rome/it-sa/positano',
        },
        {
            departCity: 'Roma',
            arriveCity: 'Firenze',
            url: '/bus/it-rm/rome/it-fi/florence',
        },
        {
            departCity: 'Napoli',
            arriveCity: 'Roma',
            url: '/bus/it-na/naples/it-rm/rome',
        },
        {
            departCity: 'Firenze',
            arriveCity: 'Siena',
            url: '/bus/it-fi/florence/it-si/siena',
        },
        {
            departCity: 'Venezia',
            arriveCity: 'Roma',
            url: '/bus/it-ve/venice/it-rm/rome',
        },
        {
            departCity: 'Roma',
            arriveCity: 'Bari',
            url: '/bus/it-rm/rome/it-ba/bari',
        },
        {
            departCity: 'Firenze',
            arriveCity: 'Venezia',
            url: '/bus/it-fi/florence/it-ve/venice',
        },
        {
            departCity: 'Roma',
            arriveCity: 'Milano',
            url: '/bus/it-rm/rome/it-mi/milan',
        },
    ],
    'nl-nl': [
        {
            departCity: 'Amsterdam',
            arriveCity: 'Berlin',
            url: '/bus/nl-nh/amsterdam/de-be/berlin',
        },
        {
            departCity: 'Amsterdam',
            arriveCity: 'Paris',
            url: '/bus/nl-nh/amsterdam/fr/paris',
        },
        {
            departCity: 'Rotterdam',
            arriveCity: 'Luchthaven Schiphol',
            url: '/bus/nl-zh/rotterdam/nl-nh/schiphol',
        },
        {
            departCity: 'Groningen',
            arriveCity: 'Bremen',
            url: '/bus/nl-gr/groningen/de-hb/bremen',
        },
        {
            departCity: 'Enschede',
            arriveCity: 'Amsterdam',
            url: '/bus/nl-ov/enschede/nl-nh/amsterdam',
        },
        {
            departCity: 'Brussel',
            arriveCity: 'Amsterdam',
            url: '/bus/be-bru/brussels/nl-nh/amsterdam',
        },
        {
            departCity: 'London',
            arriveCity: 'Amsterdam',
            url: '/bus/gb-lnd/london/nl-nh/amsterdam',
        },
        {
            departCity: 'Amsterdam',
            arriveCity: 'Hamburg',
            url: '/bus/nl-nh/amsterdam/de-hh/hamburg',
        },
    ],
};

const TRAIN_C2C_DATA = {
    'en-us': [
        {
            departCity: 'Boston',
            arriveCity: 'NYC',
            url: '/train/us-ma/boston/us-ny/new-york',
        },
        {
            departCity: 'NYC',
            arriveCity: 'Boston',
            url: '/train/us-ny/new-york/us-ma/boston',
        },
        {
            departCity: 'DC',
            arriveCity: 'NYC',
            url: '/train/us-dc/washington/us-ny/new-york',
        },
        {
            departCity: 'NYC',
            arriveCity: 'DC',
            url: '/train/us-ny/new-york/us-dc/washington',
        },
        {
            departCity: 'San Diego',
            arriveCity: 'LA',
            url: '/train/us-ca/san-diego/us-ca/los-angeles',
        },
        {
            departCity: 'LA',
            arriveCity: 'San Diego',
            url: '/train/us-ca/los-angeles/us-ca/san-diego',
        },
        {
            departCity: 'Seattle',
            arriveCity: 'Vancouver',
            url: '/train/us-wa/seattle/ca-bc/vancouver',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Seattle',
            url: '/train/ca-bc/vancouver/us-wa/seattle',
        },
        {
            departCity: 'Philadelphia',
            arriveCity: 'NYC',
            url: '/train/us-pa/philadelphia/us-ny/new-york',
        },
        {
            departCity: 'NYC',
            arriveCity: 'Baltimore',
            url: '/train/us-ny/new-york/us-md/baltimore',
        },
        {
            departCity: 'Newark',
            arriveCity: 'DC',
            url: '/train/us-nj/newark/us-dc/washington',
        },
    ],
    'de-de': [
        {
            departCity: 'München',
            arriveCity: 'Berlin',
            url: '/train/de-by/munich/de-be/berlin',
        },
        {
            departCity: 'Hamburg',
            arriveCity: 'Berlin',
            url: '/train/de-hh/hamburg/de-be/berlin',
        },
        {
            departCity: 'München',
            arriveCity: 'Wein',
            url: '/train/de-by/munich/at/vienna',
        },
        {
            departCity: 'Frankfurt',
            arriveCity: 'Berlin',
            url: '/train/de-he/frankfurt/de-be/berlin',
        },
        {
            departCity: 'Dortmund',
            arriveCity: 'Berlin',
            url: '/train/de-nw/dortmund/de-be/berlin',
        },
        {
            departCity: 'Berlin',
            arriveCity: 'Nuremberg',
            url: '/train/de-be/berlin/de-by/nuremberg',
        },
        {
            departCity: 'Frankfurt',
            arriveCity: 'Amterdam',
            url: '/train/de-he/frankfurt/nl-nh/amsterdam',
        },
        {
            departCity: 'Essen',
            arriveCity: 'Berlin',
            url: '/train/de-nw/essen/de-be/berlin',
        },
    ],
    'en-ca': [
        {
            departCity: 'Montreal',
            arriveCity: 'Toronto',
            url: '/train/ca-qc/montreal/ca-on/toronto',
        },
        {
            departCity: 'Toronto',
            arriveCity: 'Montreal',
            url: '/train/ca-on/toronto/ca-qc/montreal',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Toronto',
            url: '/train/ca-bc/vancouver/ca-on/toronto',
        },
        {
            departCity: 'Toronto',
            arriveCity: 'Vancouver',
            url: '/train/ca-on/toronto/ca-bc/vancouver',
        },
        {
            departCity: 'Quebec City',
            arriveCity: 'Toronto',
            url: '/train/ca-qc/quebec-city/ca-on/toronto',
        },
        {
            departCity: 'Toronto',
            arriveCity: 'Quebec City',
            url: '/train/ca-on/toronto/ca-qc/quebec-city',
        },
        {
            departCity: 'Ottawa',
            arriveCity: 'Toronto',
            url: '/train/ca-on/ottawa/ca-on/toronto',
        },
        {
            departCity: 'Toronto',
            arriveCity: 'Ottawa',
            url: '/train/ca-on/toronto/ca-on/ottawa',
        },
    ],
    'en-gb': [
        {
            departCity: 'London',
            arriveCity: 'Hamburg',
            url: '/train/gb-lnd/london/de-hh/hamburg',
        },
        {
            departCity: 'London',
            arriveCity: 'Paris',
            url: '/train/gb-lnd/london/fr/paris',
        },
        {
            departCity: 'Paris',
            arriveCity: 'London',
            url: '/train/fr/paris/gb-lnd/london',
        },
        {
            departCity: 'New York',
            arriveCity: 'Washington DC',
            url: '/train/us-ny/new-york/us-dc/washington',
        },
        {
            departCity: 'San Diego',
            arriveCity: 'Los Angeles',
            url: '/train/us-ca/san-diego/us-ca/los-angeles',
        },
        {
            departCity: 'Los Angeles',
            arriveCity: 'San Diego',
            url: '/train/us-ca/los-angeles/us-ca/san-diego',
        },
        {
            departCity: 'Seattle',
            arriveCity: 'Vancouver',
            url: '/train/us-wa/seattle/ca-bc/vancouver',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Seattle',
            url: '/train/ca-bc/vancouver/us-wa/seattle',
        },
    ],
    'es-es': [
        {
            departCity: 'Boston',
            arriveCity: 'Nueva York',
            url: '/train/us-ma/boston/us-ny/new-york',
        },
        {
            departCity: 'Nueva York',
            arriveCity: 'Boston',
            url: '/train/us-ny/new-york/us-ma/boston',
        },
        {
            departCity: 'Washington DC',
            arriveCity: 'Nueva York',
            url: '/train/us-dc/washington/us-ny/new-york',
        },
        {
            departCity: 'Nueva York',
            arriveCity: 'Washington DC',
            url: '/train/us-ny/new-york/us-dc/washington',
        },
        {
            departCity: 'San Diego',
            arriveCity: 'Los Angeles',
            url: '/train/us-ca/san-diego/us-ca/los-angeles',
        },
        {
            departCity: 'Los Angeles',
            arriveCity: 'San Diego',
            url: '/train/us-ca/los-angeles/us-ca/san-diego',
        },
        {
            departCity: 'Seattle',
            arriveCity: 'Vancouver',
            url: '/train/us-wa/seattle/ca-bc/vancouver',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Seattle',
            url: '/train/ca-bc/vancouver/us-wa/seattle',
        },
    ],
    'es-mx': [
        {
            departCity: 'Boston',
            arriveCity: 'Nueva York',
            url: '/train/us-ma/boston/us-ny/new-york',
        },
        {
            departCity: 'Nueva York',
            arriveCity: 'Boston',
            url: '/train/us-ny/new-york/us-ma/boston',
        },
        {
            departCity: 'Washington DC',
            arriveCity: 'Nueva York',
            url: '/train/us-dc/washington/us-ny/new-york',
        },
        {
            departCity: 'Nueva York',
            arriveCity: 'Washington DC',
            url: '/train/us-ny/new-york/us-dc/washington',
        },
        {
            departCity: 'San Diego',
            arriveCity: 'Los Angeles',
            url: '/train/us-ca/san-diego/us-ca/los-angeles',
        },
        {
            departCity: 'Los Angeles',
            arriveCity: 'San Diego',
            url: '/train/us-ca/los-angeles/us-ca/san-diego',
        },
        {
            departCity: 'Seattle',
            arriveCity: 'Vancouver',
            url: '/train/us-wa/seattle/ca-bc/vancouver',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Seattle',
            url: '/train/ca-bc/vancouver/us-wa/seattle',
        },
    ],
    'fr-ca': [
        {
            departCity: 'Québec',
            arriveCity: 'Montréal',
            url: '/train/ca-qc/quebec-city/ca-qc/montreal',
        },
        {
            departCity: 'Montréal',
            arriveCity: 'Québec',
            url: '/train/ca-qc/montreal/ca-qc/quebec-city',
        },
        {
            departCity: 'Montréal',
            arriveCity: 'Toronto',
            url: '/train/ca-qc/montreal/ca-on/toronto',
        },
        {
            departCity: 'Toronto',
            arriveCity: 'Montréal',
            url: '/train/ca-on/toronto/ca-qc/montreal',
        },
        {
            departCity: 'Montréal',
            arriveCity: 'Vancouver',
            url: '/train/ca-qc/montreal/ca-bc/vancouver',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Montréal',
            url: '/train/ca-bc/vancouver/ca-qc/montreal',
        },
        {
            departCity: 'Montréal',
            arriveCity: 'New York',
            url: '/train/ca-qc/montreal/us-ny/new-york',
        },
        {
            departCity: 'New York',
            arriveCity: 'Montréal',
            url: '/train/us-ny/new-york/ca-qc/montreal',
        },
    ],
    'fr-fr': [
        {
            departCity: 'Paris',
            arriveCity: 'Londres',
            url: '/train/fr/paris/gb-lnd/london',
        },
        {
            departCity: 'Londres',
            arriveCity: 'Paris',
            url: '/train/gb-lnd/london/fr/paris',
        },
        {
            departCity: 'Paris',
            arriveCity: 'Berlin',
            url: '/train/fr/paris/de-be/berlin',
        },
        {
            departCity: 'New York',
            arriveCity: 'Washington DC',
            url: '/train/us-ny/new-york/us-dc/washington',
        },
        {
            departCity: 'San Diego',
            arriveCity: 'Los Angeles',
            url: '/train/us-ca/san-diego/us-ca/los-angeles',
        },
        {
            departCity: 'Los Angeles',
            arriveCity: 'San Diego',
            url: '/train/us-ca/los-angeles/us-ca/san-diego',
        },
        {
            departCity: 'Seattle',
            arriveCity: 'Vancouver',
            url: '/train/us-wa/seattle/ca-bc/vancouver',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Seattle',
            url: '/train/ca-bc/vancouver/us-wa/seattle',
        },
    ],
    'it-it': [
        {
            departCity: 'Milano',
            arriveCity: 'Frankfurt',
            url: '/train/it-mi/milan/de-he/frankfurt',
        },
        {
            departCity: 'New York',
            arriveCity: 'Boston',
            url: '/train/us-ny/new-york/us-ma/boston',
        },
        {
            departCity: 'Washington DC',
            arriveCity: 'New York',
            url: '/train/us-dc/washington/us-ny/new-york',
        },
        {
            departCity: 'New York',
            arriveCity: 'Washington DC',
            url: '/train/us-ny/new-york/us-dc/washington',
        },
        {
            departCity: 'San Diego',
            arriveCity: 'Los Angeles',
            url: '/train/us-ca/san-diego/us-ca/los-angeles',
        },
        {
            departCity: 'Los Angeles',
            arriveCity: 'San Diego',
            url: '/train/us-ca/los-angeles/us-ca/san-diego',
        },
        {
            departCity: 'Seattle',
            arriveCity: 'Vancouver',
            url: '/train/us-wa/seattle/ca-bc/vancouver',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Seattle',
            url: '/train/ca-bc/vancouver/us-wa/seattle',
        },
    ],
    'nl-nl': [
        {
            departCity: 'Amsterdam',
            arriveCity: 'Hamburg',
            url: '/train/nl-nh/amsterdam/de-hh/hamburg',
        },
        {
            departCity: 'Rotterdam',
            arriveCity: 'Berlin',
            url: '/train/nl-zh/rotterdam/de-be/berlin',
        },
        {
            departCity: 'Washington DC',
            arriveCity: 'New York',
            url: '/train/us-dc/washington/us-ny/new-york',
        },
        {
            departCity: 'New York',
            arriveCity: 'Washington DC',
            url: '/train/us-ny/new-york/us-dc/washington',
        },
        {
            departCity: 'San Diego',
            arriveCity: 'Los Angeles',
            url: '/train/us-ca/san-diego/us-ca/los-angeles',
        },
        {
            departCity: 'Los Angeles',
            arriveCity: 'San Diego',
            url: '/train/us-ca/los-angeles/us-ca/san-diego',
        },
        {
            departCity: 'Seattle',
            arriveCity: 'Vancouver',
            url: '/train/us-wa/seattle/ca-bc/vancouver',
        },
        {
            departCity: 'Vancouver',
            arriveCity: 'Seattle',
            url: '/train/ca-bc/vancouver/us-wa/seattle',
        },
    ],
};

const CARRIER_DROP_DOWN_DATA = {
    'en-us': [
        {
            carrierName: 'Amtrak',
            url: '/carrier/amtrak-train-146',
        },
        {
            carrierName: 'Acela',
            url: '/carrier/acela-182',
        },
        {
            carrierName: 'Greyhound Bus',
            url: '/carrier/greyhound-bus-lines-139',
        },
        {
            carrierName: 'FlixBus USA',
            url: '/carrier/flixbus-us-1956',
        },
        {
            carrierName: 'Peter Pan Bus',
            url: '/carrier/peter-pan-bus-lines-132',
        },
        {
            carrierName: 'Red Coach',
            url: '/carrier/red-coach-148',
        },
        {
            carrierName: 'California Zephyr',
            url: '/carrier/amtrak-california-zephyr-186',
        },
        {
            carrierName: 'All Companies',
            url: '/carrier',
        },
    ],
    'en-ca': [
        {
            carrierName: 'VIA Rail',
            url: '/carrier/',
        },
        {
            carrierName: 'Ebus',
            url: '/carrier/ebus-38/',
        },
        {
            carrierName: 'Red Arrow',
            url: '/carrier/red-arrow-98',
        },
        {
            carrierName: 'Maritime Bus',
            url: '/carrier/maritime-bus-241',
        },
        {
            carrierName: 'Cold Shot',
            url: '/carrier/cold-shot-bus-1338',
        },
        {
            carrierName: 'Ontario Northland',
            url: '/carrier/ontario-northland-1189',
        },
        {
            carrierName: 'Greyhound Bus',
            url: '/carrier/greyhound-bus-lines-139',
        },
        {
            carrierName: 'All Companies',
            url: '/carrier',
        },
    ],
    'fr-ca': [
        {
            carrierName: 'VIA Rail',
            url: '/carrier/',
        },
        {
            carrierName: 'Ebus',
            url: '/carrier/ebus-38',
        },
        {
            carrierName: 'Red Arrow',
            url: '/carrier/red-arrow-98',
        },
        {
            carrierName: 'Maritime Bus',
            url: '/carrier/maritime-bus-241',
        },
        {
            carrierName: 'Cold Shot',
            url: '/carrier/cold-shot-bus-1338',
        },
        {
            carrierName: 'Ontario Northland',
            url: '/carrier/ontario-northland-1189',
        },
        {
            carrierName: 'Greyhound Bus',
            url: '/carrier/greyhound-bus-lines-139',
        },
        {
            carrierName: 'Toutes les Entreprises',
            url: '/carrier',
        },
    ],
    'es-mx': [
        {
            carrierName: 'Tornado Bus',
            url: '/carrier/tornado-bus-company-74',
        },
        {
            carrierName: 'Tufesa International',
            url: '/carrier/tufesa-international-123',
        },
        {
            carrierName: 'El Expresso',
            url: '/carrier/el-expreso-bus-235',
        },
        {
            carrierName: 'AVE Senda',
            url: '/carrier/ave-senda-169',
        },
        {
            carrierName: 'Transportes del Norte',
            url: '/carrier/transportes-del-norte-tdn-164',
        },
        {
            carrierName: 'Greyhound Bus',
            url: '/carrier/greyhound-bus-lines-139',
        },
        {
            carrierName: 'Autobuses Torres',
            url: '/carrier/autobuses-torres-1266',
        },
        {
            carrierName: 'Todas las Empresas',
            url: '/carrier',
        },
    ],
    'nl-nl': [
        {
            carrierName: 'FlixBus',
            url: '/carrier/flixbus-206',
        },
        {
            carrierName: 'Deutsche Bahn',
            url: '/carrier/deutsche-bahn-db-196',
        },
        {
            carrierName: 'National Express',
            url: '/carrier/national-express-coach-224',
        },
        {
            carrierName: 'RailJet',
            url: '/carrier/railjet-238',
        },
        {
            carrierName: 'Amsterdam Airport Express',
            url: '/carrier/amsterdam-airport-express-1196',
        },
        {
            carrierName: 'CityBusExpress',
            url: '/carrier/citybusexpress-243',
        },
        {
            carrierName: 'BlaBlaBus',
            url: '/carrier/blablabus-1955',
        },
        {
            carrierName: 'Alle Bedrijven',
            url: '/carrier',
        },
    ],
    'fr-fr': [
        {
            carrierName: 'FlixBus',
            url: '/carrier/flixbus-206',
        },
        {
            carrierName: 'Deutsche Bahn',
            url: '/carrier/deutsche-bahn-db-196',
        },
        {
            carrierName: 'National Express',
            url: '/carrier/national-express-coach-224',
        },
        {
            carrierName: 'Navette Paris-Beauvais',
            url: '/carrier/navette-paris-beauvais-1184',
        },
        {
            carrierName: 'Le Bus Direct',
            url: '/carrier/le-bus-direct-1154',
        },
        {
            carrierName: 'Eurostar',
            url: '/carrier/eurostar-1952',
        },
        {
            carrierName: 'BlaBlaBus',
            url: '/carrier/blablabus-1955',
        },
        {
            carrierName: 'Toutes les Entreprises',
            url: '/carrier',
        },
    ],
    'en-gb': [
        {
            carrierName: 'FlixBus',
            url: '/carrier/flixbus-206',
        },
        {
            carrierName: 'Deutsche Bahn',
            url: '/carrier/deutsche-bahn-db-196',
        },
        {
            carrierName: 'National Express',
            url: '/carrier/national-express-coach-224',
        },
        {
            carrierName: 'Eurostar',
            url: '/carrier/eurostar-1952',
        },
        {
            carrierName: 'BlaBlaBus',
            url: '/carrier/blablabus-1955',
        },
        {
            carrierName: 'Greyhound Bus',
            url: '/carrier/greyhound-bus-lines-139',
        },
        {
            carrierName: 'Amtrak',
            url: '/carrier/amtrak-train-146',
        },
        {
            carrierName: 'All Companies',
            url: '/carrier',
        },
    ],
    'it-it': [
        {
            carrierName: 'FlixBus',
            url: '/carrier/flixbus-206',
        },
        {
            carrierName: 'Sita',
            url: '/carrier/sita-1085',
        },
        {
            carrierName: 'Marozzi',
            url: '/carrier/marozzi-1083',
        },
        {
            carrierName: 'Itabus',
            url: '/carrier/itabus-1959',
        },
        {
            carrierName: 'Cortina Express',
            url: '/carrier/cortina-express-1927',
        },
        {
            carrierName: 'Marino Bus',
            url: '/carrier/marino-1081',
        },
        {
            carrierName: 'BlaBlaBus',
            url: '/carrier/blablabus-1955',
        },
        {
            carrierName: 'Tutte le Aziende',
            url: '/carrier',
        },
    ],
    'es-es': [
        {
            carrierName: 'FlixBus',
            url: '/carrier/flixbus-206',
        },
        {
            carrierName: 'Deutsche Bahn',
            url: '/carrier/deutsche-bahn-db-196',
        },
        {
            carrierName: 'Balearia',
            url: '/carrier/balearia-1226',
        },
        {
            carrierName: 'BlaBlaBus',
            url: '/carrier/blablabus-1955',
        },
        {
            carrierName: 'Greyhound Bus',
            url: '/carrier/greyhound-bus-lines-139',
        },
        {
            carrierName: 'Amtrak',
            url: '/carrier/amtrak-train-146',
        },
        {
            carrierName: 'Todas las empresas',
            url: '/carrier',
        },
    ],
    'de-de': [
        {
            carrierName: 'FlixBus',
            url: '/carrier/flixbus-206',
        },
        {
            carrierName: 'Deutsche Bahn',
            url: '/carrier/deutsche-bahn-db-196',
        },
        {
            carrierName: 'National Express',
            url: '/carrier/national-express-coach-224',
        },
        {
            carrierName: 'DB ICE - Intercity Express',
            url: '/carrier/db-intercity-express-1015',
        },
        {
            carrierName: 'DB Intercity - IC',
            url: '/carrier/deutsche-bahn-intercity-db-ic-208',
        },
        {
            carrierName: 'BlaBlaBus',
            url: '/carrier/blablabus-1955',
        },
        {
            carrierName: 'Amtrak',
            url: '/carrier/amtrak-train-146',
        },
        {
            carrierName: 'Alle Unternehmen',
            url: '/carrier',
        },
    ],
};

function mapCarrierToData(carrierId) {
    return CARRIER_DATA[carrierId];
}

const carrierMap = {
    'en-us': FEATURED_EN_US_CARRIER_CODES.map(mapCarrierToData).filter(Boolean),
    'en-ca': FEATURED_EN_CA_CARRIER_CODES.map(mapCarrierToData).filter(Boolean),
    'en-gb': FEATURED_EN_GB_CARRIER_CODES.map(mapCarrierToData).filter(Boolean),
    'es-mx': FEATURED_ES_MX_CARRIER_CODES.map(mapCarrierToData).filter(Boolean),
    'es-es': FEATURED_ES_ES_CARRIER_CODES.map(mapCarrierToData).filter(Boolean),
    'fr-fr': FEATURED_FR_FR_CARRIER_CODES.map(mapCarrierToData).filter(Boolean),
    'fr-ca': FEATURED_FR_CA_CARRIER_CODES.map(mapCarrierToData).filter(Boolean),
    'de-de': FEATURED_DE_DE_CARRIER_CODES.map(mapCarrierToData).filter(Boolean),
    'nl-nl': FEATURED_NL_NL_CARRIER_CODES.map(mapCarrierToData).filter(Boolean),
    'it-it': FEATURED_IT_IT_CARRIER_CODES.map(mapCarrierToData).filter(Boolean),
    seoBus: BUS_C2C_DATA,
    seoTrain: TRAIN_C2C_DATA,
    carrierDropDown: CARRIER_DROP_DOWN_DATA,
};

export default carrierMap;
